// src/types/roles.ts

import type { ForwardRefExoticComponent, RefAttributes } from "react";
import type { LucideProps } from "lucide-react";

// 🔐 Tous les rôles possibles dans l'application
export type UserRole = "patient" | "doctor" | "admin" | "secretary";

// 📌 Structure d’un item de menu principal (général)
export type MenuItem = {
  path: string;
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
  >;
  label: string;
};

// 📌 Item de sous-menu pour les rôles étendus (admin/secretary)
export type AccountSubMenuItem = {
  path: string;
  label: string;
};

// 🧱 Base de configuration commune à tous les rôles
export type BaseRoleConfig = {
  title: string;
  userLabel: string;
  userEmail: string;
  loginRoute: string;
  menuItems: MenuItem[];
};

// 🛠️ Config étendue pour les rôles avec sous-menu (admin, secretary)
export type AdminRoleConfig = BaseRoleConfig & {
  accountSubMenu: AccountSubMenuItem[];
};

// 🗺️ Mapping global typé de toutes les configurations par rôle
export type RoleConfigs = {
  patient: BaseRoleConfig;
  doctor: BaseRoleConfig;
  admin: AdminRoleConfig;
  secretary: AdminRoleConfig;
};

// ✅ Type guard utile pour savoir si une config a un sous-menu
export const isAdminConfig = (
  config: BaseRoleConfig
): config is AdminRoleConfig => {
  return "accountSubMenu" in config;
};
